import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";

export function ErrorMessage() {
  const params = new URLSearchParams(useLocation().search);
  const { t } = useTranslation();
  const navigate = useNavigate();

  function handleLogin() {
    navigate("/login");
  }

  const decodeString = ((param: any) => {
    return decodeURI(param);
  })

  return (
    <div style={{ textAlign: "center" }}>
      <h1>{params.get("status")}</h1>
      <h2>{decodeString(params.get("error"))}</h2>
      <h3>{decodeString(params.get("message"))}</h3>
      {params.get("status") === "401" ? (
        <Button onClick={handleLogin}>{t("sessionTimeOut.newLogin")}</Button>
      ) : null}
    </div>
  );
}
